import type { TrashByJobUuidAndFileUuidParams } from '~/@types/backend-types'
import { ThumbArea } from '~/@types/backend-types'
import { getPasswordForJob } from '~/query'
import { getForeignAuthParam } from '~/query/api'

import type { ServiceDict } from '../externals'
import { HostUrl } from '../toolbox'

import { APIService } from './APIService'

export class ThumbService extends APIService {
    private hostUrl: HostUrl
    private prefetchCaches: Set<URLstring> = new Set()

    constructor(services: ServiceDict, authToken: string | undefined) {
        super('thumbHost', services, authToken)
        const { commonParams } = this.getRequestContext()
        this.hostUrl = new HostUrl(services.thumbHost, {
            ...commonParams,
            auth: authToken,
        })
    }

    // area[small, large] = [256, 1280]
    public getThumbUrl(jobID: JobID, fileID: FileID, area: ThumbArea = ThumbArea.SMALL): URLstring {
        const password = getPasswordForJob(jobID)
        return this.hostUrl.getPath(`/th/3/${fileID}`, {
            area,
            share: jobID,
            ...getForeignAuthParam(password),
        })
    }

    public getTimelineThumbUrl(fileID: FileID, area: ThumbArea = ThumbArea.SMALL): URLstring {
        return this.hostUrl.getPath(`/th/3/${fileID}`, {
            area,
        })
    }

    // area[small, large] = [256, 1280]
    public getTrashedThumbUrl(
        jobID: JobID,
        fileID: FileID,
        params: TrashByJobUuidAndFileUuidParams,
    ): URLstring {
        const password = getPasswordForJob(jobID)
        return this.hostUrl.getPath(`/th/3/trash/${jobID}/${fileID}`, {
            ...params,
            ...getForeignAuthParam(password),
        })
    }

    private _prefetchThumb(url: URLstring): void {
        if (this.prefetchCaches.has(url)) {
            return
        }

        const preload = new Image()
        preload.onload = () => {
            this.prefetchCaches.add(url)
        }
        preload.onerror = () => {
            this.prefetchCaches.delete(url)
        }
        preload.src = url
    }

    public prefetchTimelineThumb(fileID: FileID, area: ThumbArea = ThumbArea.SMALL) {
        this._prefetchThumb(this.getTimelineThumbUrl(fileID, area))
    }
}
